import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32d02cd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no-permission-wrapper" }

import { NResult } from 'naive-ui'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'NoPermission',
  setup(__props) {

const { t } = useI18n()
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.content.noPermission.${key}`, ...params)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NResult), {
      status: "403",
      title: $tt('errorCode403'),
      description: ""
    }, null, 8, ["title"])
  ]))
}
}

})